import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
} from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import { VsaaColorTokens } from "../../style/VsaaColorTokens";

const useStyles = makeStyles({
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  warningIcon: {
    color: VsaaColorTokens.color_warning_icon,
    flexShrink: 0,
  },
  warningTitle: {
    color: VsaaColorTokens.color_warning_icon,
  },
  warningMessage: {
    margin: 0,
    padding: "14px 16px",
    borderLeft: `4px solid ${VsaaColorTokens.color_warning_border}`,
    borderRadius: "6px",
    backgroundColor: VsaaColorTokens.color_warning_background,
  },
  defaultMessage: {
    margin: 0,
  },
});

interface CancelDraftDialogProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title?: string;
  message?: string;
  isWarning?: boolean;
}

export const CancelDraftDialog = ({
  isOpen,
  onCancel,
  onConfirm,
  isLoading = false,
  title,
  message,
  isWarning = false,
}: CancelDraftDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => !data.open && onCancel()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            <span className={classes.titleRow}>
              {isWarning && (
                <Warning24Filled
                  className={classes.warningIcon}
                  data-testid="cancel-draft-warning-icon"
                />
              )}
              <span className={isWarning ? classes.warningTitle : undefined}>
                {title ?? t("cancelDraftDialogTitle")}
              </span>
            </span>
          </DialogTitle>
          <DialogContent>
            <p
              className={
                isWarning ? classes.warningMessage : classes.defaultMessage
              }
            >
              {message ?? t("cancelDraftDialogMessage")}
            </p>
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              onClick={onCancel}
              disabled={isLoading}
            >
              {t("no")}
            </Button>
            <Button
              appearance="primary"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {t("yes")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
